import React from 'react';
import styles from './styles.module.scss';

interface BasicCheckboxProps {
  id: string;
  checked?: boolean;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  innerRef?: React.Ref<HTMLInputElement>;
  color?: 'highlight' | 'accent' | 'green' | 'red';
  /** `data-testid` of the wrapper (the native input is visually replaced by its label). */
  testId?: string;
}

export const BasicCheckbox: React.FC<BasicCheckboxProps> = ({
  id,
  checked,
  onChange,
  innerRef,
  color = 'highlight',
  testId,
}) => {
  return (
    <div className={`${styles.checkbox} ${styles[color]}`} data-testid={testId}>
      <input
        type="checkbox"
        id={id}
        checked={checked}
        onChange={onChange}
        ref={innerRef}
      />
      <label htmlFor={id} />
    </div>
  );
};

export default BasicCheckbox;
